const galleryImages = [
  {
    url: "https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?w=500&auto=format&fit=crop",
    alt: "Café ambience",
  },
  {
    url: "https://images.unsplash.com/photo-1442512595331-e89e73853f31?w=500&auto=format&fit=crop",
    alt: "Coffee art",
  },
  {
    url: "https://images.unsplash.com/photo-1554118811-1e0d58224f24?w=500&auto=format&fit=crop",
    alt: "Cozy café corner",
  },
  {
    url: "https://images.unsplash.com/photo-1514432324607-a09d9b4aefdd?w=500&auto=format&fit=crop",
    alt: "Coffee cup",
  },
  {
    url: "https://images.unsplash.com/photo-1600093463592-8e36ae95ef56?w=500&auto=format&fit=crop",
    alt: "Pastries & treats",
  },
  {
    url: "https://images.unsplash.com/photo-1521017432531-fbd92d768814?w=500&auto=format&fit=crop",
    alt: "Café interior",
  },
];

export default galleryImages;
